import type { FC } from 'react';

import type { Props } from '@/components/TreatmentGroupDetailSections/components/DetailField/types';
import { Typography } from '@/ui';

const DetailField: FC<Props> = ({ label, value }) => (
  <div>
    <Typography variant="label" muted className="mb-0.5">
      {label}
    </Typography>
    <Typography variant="body">{value}</Typography>
  </div>
);

export default DetailField;
